import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lib-shared-library',
    template: `
    <p>
      shared-library works!
    </p>
  `,
    styles: [],
    standalone: false
})
export class SharedLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
